import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiListItemIcon from "@mui/material/ListItemIcon";
import classNames from "classnames";
export const ListItemIcon = props => {
  const {
    className,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiListItemIcon, _extends({}, otherProps, {
    className: classNames("prmbl-listItemIcon", className)
  }));
};

/**
 * @deprecated use `ListItemIconProps` instead
 */

export default ListItemIcon;